import styled from 'styled-components';
import { Heading, Div } from '@certilogo/design-system-web';

export const Wrapper = styled(Div)`
  position: relative;
`;

export const Title = styled(Heading).attrs({ type: 'h2' })`
  text-align: center;
`;
